import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join',
  standalone: false,
})
export class JoinPipe implements PipeTransform {
  transform(values: any[] | null, name: string, separator?: string): string {
    if (!values) {
      return '';
    }

    return values.map(item => name.split('.').reduce((obj, key) => obj?.[key], item)).join(separator || '');
  }
}
